module.exports = __webpack_public_path__ + "static/media/style-bg.95fa9825.png";